<template>
  <van-popup v-model:show="showPopup" :close-on-click-overlay="false" :z-index="zIndex">
    <slot />
    <img src="@a/assets/images/i_close.png" class="size-[40px] mx-auto mt-[24px]" @click="showPopup = false"/>
  </van-popup>
  <Image :src="popupIcon" :class="['popupIcon', position, {animateIcon}]" v-if="show" @click="showPopup = true" />
</template>

<script setup lang="ts">
  const {list, popupIcon, position, zIndex,  animateIcon} = defineProps<{
    list: any[]
    popupIcon?: any
    position?: 'left' | 'right'
    zIndex?: number
    animateIcon?: boolean
  }>()

  const showPopup = ref(false)
  const show = ref(false)

  watch(() => list.length, val => {
    showPopup.value = !!val
    show.value = !!val
  }, { immediate: true })
</script>

<style lang="scss" scoped>
  .popupIcon{
    @apply size-25 fixed-b-22;
  }
  .left{
    @apply left-4;
  }
  .right{
    @apply right-4;
  }
  .animateIcon{
    // @apply animate-ping
    animation: scale-up-center 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) infinite both;
  }

  @keyframes scale-up-center {
    0% {
      transform: scale(0.8);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
